"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMap = void 0;
var types_1 = require("remota-common/types");
function toMap(items, toKey, toValue, merge) {
    return items.reduce(function (map, item) {
        var value = toValue(item);
        if (!value) {
            return map;
        }
        var key = toKey(item);
        var prev = map.get(key);
        if (prev && merge) {
            return map.set(key, merge(prev, value));
        }
        else {
            return map.set(key, value);
        }
    }, new types_1.HashMap());
}
exports.toMap = toMap;
